import type { CellStatus } from '@eombor/contracts';
import type { BadgeTone } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';

/**
 * Katak holatining ko'rinishi. Bitta joyda turadi, chunki uni kartochka ham,
 * ro'yxat ham, 3D sahnaning `sr-only` jadvali ham chizadi — uch joyda ayri
 * yozilsa bir kuni uchtasi uch xil so'z ko'rsatadi.
 *
 * Ranglar ma'nosi: bo'sh — mahsulot QO'YISH mumkin (yashil), band — ish
 * ketmoqda (ko'k), bloklangan — tegilmaydi (qizil).
 */
const TONES: Record<CellStatus, BadgeTone> = {
  FREE: 'success',
  OCCUPIED: 'info',
  BLOCKED: 'danger',
};

export const cellStatusTone = (status: CellStatus): BadgeTone => TONES[status];

export const cellStatusLabel = (status: CellStatus): string => t(`warehouse.cellStatus${status}`);

/** Vositalar panelidagi filtr: `all` — hech narsa filtrlanmaydi. */
export const CELL_FILTERS = ['all', 'FREE', 'OCCUPIED', 'BLOCKED'] as const;

export type CellFilter = (typeof CELL_FILTERS)[number];

export const cellFilterLabel = (filter: CellFilter): string =>
  filter === 'all' ? t('warehouse.filterAll') : cellStatusLabel(filter);

export const matchesCellFilter = (status: CellStatus, filter: CellFilter): boolean =>
  filter === 'all' || status === filter;
